<template>
  <div class="xpress-page-content xpress-user-admin-approval">
    <!-- loading spinner -->
    <n-modal v-model:show="loading">
      <page-spinner :onloader="'flex'" />
    </n-modal>

    <!-- sidebar -->
    <sidebar
      :sidebarActive="isSidebarActive"
    >
      <!-- slot for user sidebar navigation links -->
      <admin-sidebar />
      <!----------------------------------- -->
    </sidebar>

    <section>
      <!-- navbar -->
      <navbar
        @sidebarToggled="sidebarToggled($event)"
      />
      <!----------------------------------->
      <main>
        <!-- approval table section -->
        <section class="xpress-inhouse-content-section">
          <!-- audit trail table -->
          <ApiMerchantsTable />
        </section>
      </main>
      <!-- ------ -->
      <MainFooter />
    </section>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, provide, ref } from 'vue'
import { useStore } from 'vuex'
import { NModal } from 'naive-ui'

import Sidebar from '@/components/sidebar.vue'
import MainFooter from '@/components/mainFooter.vue'
import AdminSidebar from '@/components/sidebar/adminSidebar.vue'
import Navbar from '@/components/navbar.vue'
// API Merchants tables
import ApiMerchantsTable from '@/components/table/approvals/admin/api-merchant-approval/apiMerchants.vue'
// ---------------------------------------
import PageSpinner from '@/components/PageSpinner.vue'

import { GetAllWhiteLabelCompanies } from '@/mixins/use-white-label-for-company'

provide('page-title', 'API Merchants')
provide('searchbar-placeholder', 'Search')

const store = useStore()

const loading = computed(() => store.getters._globalLoading)
const isSidebarActive = ref('')

const sidebarToggled = (isToggled) => {
  isSidebarActive.value = isToggled
}

onBeforeMount(async () => {
  // toggle spinner
  store.commit('LOADING', true)

  await GetAllWhiteLabelCompanies({
    searchValue: 'all',
    pageNumber: 1,
    pageSize: 10
  })
    .finally(() => {
      // toggle spinner
      store.commit('LOADING', false)
    })
})
</script>

<style lang="scss" scoped>
  div.xpress-page-content {
    display: grid;
    grid-template: auto / 240px auto;
    position: relative;
    overflow-x: hidden;

    &.xpress-user-admin-approval {
      // height: 100%;
      background-color: #FAFAFA;
    }

    // ALL PAGES CONTENT
    &>section {
      grid-area: 1 / 2 / 2 / 3;

      &>main {
        width: 100%;
        min-height: 90vh;
        // max-height: 100vh;
        padding: 0 40px 50px;

        // In-house content section
        &>section.xpress-inhouse-content-section {
          width: 100%;
          height: 100%;
          display: flex;
          flex-flow: column;
          padding-top: 32px;
          padding-bottom: 48px;
        }
      }
    }
  }

  // MEDIA QUERY

  // XX-SM (<251px)
  @media (max-width: 250.9px) {
    div.xpress-page-content {
      width: 100%;
      height: auto;
      display: block;

      &>section {

        &>main {
          width: 100%;
          padding: 0 2% 50px;
        }
      }
    }
  }
  // XX-SM
  @media (min-width: 251px) and (max-width: 350.9px) {
    div.xpress-page-content {
      width: 100%;
      height: auto;
      display: block;

      &>section {

        &>main {
          width: 100%;
          padding: 0 2% 50px;
        }
      }
    }
  }
  // X-SM
  @media (min-width: 351px) and (max-width: 575.9px) {
    div.xpress-page-content {
      width: 100%;
      height: auto;
      display: block;

      &>section {

        &>main {
          width: 100%;
          padding: 0 2% 50px;
        }
      }
    }
  }
  // SM
  @media (min-width: 576px) and (max-width: 767.9px) {
    div.xpress-page-content {
      width: 100%;
      height: auto;
      display: block;

      &>section {

        &>main {
          width: 100%;
          padding: 0 2% 50px;
        }
      }
    }
  }
  // MD
  @media (min-width: 768px) and (max-width: 991.9px) {
    div.xpress-page-content {
      width: 100%;
      height: auto;
      display: block;

      &>section {

        &>main {
          width: 100%;
          padding: 0 2% 50px;
        }
      }
    }
  }
  // LG
  @media (min-width: 992px) and (max-width: 1200.9px) {
    div.xpress-page-content {
      grid-template: auto / 240px auto;

      &>section {
        width: calc( 100vw - 240px);
      }
    }
  }
  // XL
  @media (min-width: 1201px) {
    div.xpress-page-content {
      grid-template: auto / 240px auto;

      &>section {
        width: calc( 100vw - 240px);
      }
    }
  }
</style>
